var interceptor = require('rest/interceptor');

export default interceptor({
  response: function (response, config, meta) {
    if (response.entity && response.entity.redirect) {
      window.open(response.entity.redirect.replace(/\{location\}/g, encodeURIComponent(window.location.href)), '_self');
      delete response.entity.redirect;
    }
    return response;
  }
});



/** WEBPACK FOOTER **
 ** ./client/app/shared/utils/redirect.interceptor.ts
 **/